'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function UnsavedChangesModel(navigatorShim, collaborationModel, storage, subscriptionModel, launchOnStart) {
	let currentQueueKey, currentFileId, currentQueue, isSubscribed, unsavedSince = 0, lastSaveStarted, lastSaveCompleted, currentFileInfo = false;
	const obj = observable(this),
		sendContext = function () {
			const unsaved = !!currentQueue && currentQueue.length > 0;
			obj.dispatchEvent('fileChangeContext', {unsaved: unsaved});
		},
		eventKey = function () {
			return 'unsaved-changes' + navigatorShim.getPath();
		},
		clearUnsaveChanges = () => {
			const key = eventKey();
			if (key !== currentQueueKey) {
				storage.remove(key);
			}
			if (currentQueueKey && currentQueue && currentQueue.length) {
				storage.remove(currentQueueKey);
				currentQueueKey = undefined;
				currentQueue = [];
			}

		},
		beforeUnloadListener = (e) => {
			if (currentQueue && currentQueue.length) {
				const unsavedMessage = 'This document has unsaved changes. If you leave now, you might lose data. If you are experiencing connectivity problems, cancel and save the data locally using File->Download As->MindMup';
				e.returnValue = unsavedMessage;
				e.preventDefault();
				return unsavedMessage;
			}
		};

	obj.notifyFileSaving = function () {
		lastSaveStarted = Date.now();
	};
	obj.notifyFileSaved = function () {
		if (!currentFileId) {
			return;
		}
		lastSaveCompleted = lastSaveStarted;
		if (lastSaveCompleted > unsavedSince) {
			obj.dispatchEvent('noUnsavedChanges');
			clearUnsaveChanges();
			sendContext();
		}
	};

	obj.discardUnsavedChanges = function () {
		clearUnsaveChanges();
		obj.dispatchEvent('unsavedChangesConfirmed');
	};
	obj.getUnsavedChanges = function () {
		if (!currentFileId) {
			return;
		}
		return storage.getItem(eventKey());
	};
	obj.applyUnsavedChanges = function (overrideEvents) {
		if (!overrideEvents && !currentFileId) {
			return;
		}
		const events = overrideEvents || storage.getItem(eventKey());
		if (events && events.length) {
			clearUnsaveChanges();
			events.forEach((evt) => {
				collaborationModel.triggerRemoteContentEvent(evt, collaborationModel.getLocalSessionId());
			});
		}
		obj.dispatchEvent('unsavedChangesConfirmed');
	};

	obj.start = (fileInfo) => {
		if (currentFileId) {
			return;
		}
		navigatorShim.addWindowEventListener('beforeunload', beforeUnloadListener);
		sendContext();
		currentFileId = fileInfo && fileInfo.fileId;
		currentFileInfo = fileInfo;
		currentQueueKey = eventKey();
		currentQueue = storage.getItem(currentQueueKey) || [];
		if (currentQueue.length && launchOnStart) {
			obj.dispatchEvent('unsavedChangesPending');
		}
		obj.dispatchEvent('started');
	};

	obj.halt = () => {
		navigatorShim.removeWindowEventListener('beforeunload', beforeUnloadListener);
		clearUnsaveChanges();
		sendContext();
		currentFileId = false;
		currentFileInfo = false;
		currentQueueKey = false;
		currentQueue = false;
		obj.dispatchEvent('halted');
	};

	obj.localContentEvent = (evt) => {
		if (!currentFileId) {
			throw new Error('not-initialised');
		}
		unsavedSince = Date.now();
		obj.dispatchEvent('unsavedChanges');
		if (isSubscribed) {
			if (currentFileInfo && currentFileInfo.free) {
				obj.dispatchEvent('free-map-subscriber-edit');
				return;
			} else if (currentFileInfo && currentFileInfo.gold) {
				collaborationModel.error('readonly');
				return;
			}
		}
		if (eventKey() !== currentQueueKey) {
			currentQueueKey = eventKey();
			currentQueue = storage.getItem(currentQueueKey) || [];
		}

		currentQueue.push(evt);
		sendContext();
		try {
			storage.setItem(currentQueueKey, currentQueue);
		} catch (e) {
			obj.dispatchEvent('unsavedChangesStorageWarning');
		}
	};
	if (subscriptionModel) {
		subscriptionModel.addEventListener('goldAccountInfo', goldAccountInfo => {
			isSubscribed = goldAccountInfo && goldAccountInfo.active;
		});
	}
};
